module.exports = __webpack_public_path__ + "img/ic_login-info_graphic-3x.c7a2b174.png";